import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

import { useChargebeePaymentElement } from './hooks/use-chargebee-payment-element';
import { getSubscriptionDisclaimerData } from '../SubscriptionDisclaimer/utils';
import { SubscriptionDisclaimer } from '../SubscriptionDisclaimer/SubscriptionDisclaimer';
import { useCheckout } from '../../../hooks/use-checkout';
import { PaymentElementSkeleton } from '../../../Skeltons/PaymentElementSkeleton';
import { usePaymentState } from '../../Checkout/hooks/use-payment-state';
import { AddressElement } from '../../Checkout/components/AddressElement/AddressElement';
import { PayButton } from '../../Checkout/components/PaymentForm/components/PayButton/PayButton';
import { useShowTaxCalculationFields } from '../../Checkout/hooks/use-show-tax-calculation-fields';
import { PaymentElementContainer } from '../../Checkout/components/PaymentElementContainer/PaymentElementContainer';

export function ChargebeePaymentElement() {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const { subscriptionData } = useCheckout();
  const { useTaxCalculationField } = useShowTaxCalculationFields();
  const isPaymentElementLoading = usePaymentState((state) => state.isPaymentElementLoading);
  const { ref, showPayButton, handlePaymentButtonClick, AddressElementRef } =
    useChargebeePaymentElement();

  // We collect a ZIP/address for tax exactly in the countries that add tax on
  // top of the price (US/CA), which is where the amount is quoted pre-tax.
  const disclaimerData = getSubscriptionDisclaimerData(subscriptionData, useTaxCalculationField);

  return (
    <PaymentElementContainer
      content={
        <Stack spacing={1}>
          <div id="payment-component" ref={ref} style={{ width: '100%' }} />
          {/* Mount the ZIP field only after the Chargebee component has loaded:
              by then the summary has seeded the zip-code store, so the field's
              initial (prefill) value is deterministic instead of racy. */}
          {useTaxCalculationField &&
            (isPaymentElementLoading ? (
              <PaymentElementSkeleton />
            ) : (
              <AddressElement ref={AddressElementRef} zipOnly isSubscription />
            ))}
        </Stack>
      }
    >
      {/* The disclaimer sits below the Chargebee component for every payment
          method: wallets (PayPal/Apple Pay/Google Pay) confirm from buttons
          inside it, card confirms from the pay button below.
          The pay button must not render without the ROSCA/FTC disclaimer. */}
      {disclaimerData && (
        <>
          <SubscriptionDisclaimer disclaimerData={disclaimerData} />
          {showPayButton && (
            <PayButton
              onClick={handlePaymentButtonClick}
              buttonText={t('subscribeAndPay')}
              hideDisclaimer
            />
          )}
        </>
      )}
    </PaymentElementContainer>
  );
}
